import { useState } from 'react';
import type { Children } from '@repo/shared/types';

import { WelcomeViewWrapperContext } from './welcome-view-wrapper-context';

export function WelcomeViewWrapperContextProvider({ children }: Children) {
  const [submitAgreementsButton, setSubmitAgreementsButton] = useState<
    HTMLButtonElement | undefined
  >(undefined);

  const [withBackgroundImage, setWithBackgroundImage] = useState(false);
  const [withNoveltyFlag, setWithNoveltyFlag] = useState(false);

  const [isP24MarketingAgreementsFormAvailable, setIsP24MarketingAgreementsFormAvailable] =
    useState(true);

  return (
    <WelcomeViewWrapperContext.Provider
      value={{
        submitAgreementsButton,
        setSubmitAgreementsButton,
        withBackgroundImage,
        setWithBackgroundImage,
        withNoveltyFlag,
        setWithNoveltyFlag,
        isP24MarketingAgreementsFormAvailable,
        setIsP24MarketingAgreementsFormAvailable,
      }}
    >
      {children}
    </WelcomeViewWrapperContext.Provider>
  );
}
